import { InputBase } from "@mui/material";
import classnames from "classnames";
import "./CDTextField.scss";
import { CDTypography } from "../text/CDTypography";
import { CDTextFieldProps } from "./CDTextFieldProps";

export const CDTextField = (props: CDTextFieldProps) => {
  const {
    label,
    isInvalid,
    helperText,
    containerTestId,
    containerProps,
    inputBaseClassName,
    ...inputBaseProps
  } = props;

  let title = label;
  if (label && typeof label === "string") {
    title = (
      <CDTypography
        variant="typography-variant-headline-5"
        className={classnames("text-field-label", { required: props.required })}
      >
        {label}
      </CDTypography>
    );
  }

  const feedback = helperText && (
    <CDTypography
      variant="typography-variant-helper-text"
      color={
        isInvalid ? "typography-color-danger" : "typography-color-text-regular"
      }
    >
      {helperText}
    </CDTypography>
  );

  return (
    <div
      className={classnames("cdata-text-field", props.className)}
      data-testid={containerTestId}
      {...containerProps}
    >
      {title}
      <InputBase
        {...inputBaseProps}
        aria-label={
          label != null && typeof label === "string" ? label : undefined
        }
        className={classnames("input-base", inputBaseClassName, {
          "is-invalid": isInvalid,
        })}
      />
      {feedback}
    </div>
  );
};
